// extracted by mini-css-extract-plugin
module.exports = {"container":"FaxManagementStyles_container__3Tyl3","content":"FaxManagementStyles_content__1Z6dW"};